// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blogEditMain {
  width: 100%;
}

.blogEditCard {
  width: 100%;
  background: #181434;
}

@media (max-width: 768px) {
  .blogEditCard .ant-card-body {
    padding: 12px;
  }
}
.blogAddImgText {
  font-size: 1vw;
}
@media (max-width: 768px) {
  .blogAddImgText {
    font-size: 14px !important;
  }
}

.blogTabBreadCrumb {
  width: 100%;
  text-align: left;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
}

.blogTabBreadCrumb .ant-breadcrumb-link {
  color: #f0592a;
}

.ant-upload-wrapper .ant-upload-drag .ant-upload {
  padding: 1.1vw !important;
}
@media (max-width: 768px) {
  .ant-upload-wrapper .ant-upload-drag .ant-upload {
    padding: 8px !important;
  }
}

.ant-upload-wrapper .ant-upload-drag {
  border: 1px dashed #ffb6a0;
}

.ant-upload-wrapper .ant-upload-drag:not(.ant-upload-disabled):hover {
  border: 1px dashed #ffb6a0;
}

.blogEditCard .ant-card-head-title {
  font-size: 1.4vw !important;
  font-weight: 400;
  color: #f0592a !important;
}
@media (max-width: 1024px) {
  .blogEditCard .ant-card-head-title {
    font-size: 20px !important;
  }
}

.blogContentText {
  font-size: 1.4vw !important;
  font-weight: 400;
  color: #f0592a !important;
}
@media (max-width: 1024px) {
  .blogContentText {
    font-size: 20px !important;
  }
}

.blogUploaderText2 {
  color: #fff;
  font-size: 1vw;
  text-align: left;
  padding-left: 2rem;
}
@media (max-width: 768px) {
  .blogUploaderText2 {
    font-size: 14px !important;
    padding-left: 12px;
  }
}

.blogAddButton {
  background: rgb(255, 255, 255);
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.72) 0%, rgb(240, 89, 42) 50%, rgba(240, 89, 42, 0.59) 100%);
  border-radius: 12.9905277402vh !important;
  box-sizing: border-box;
  color: #fff !important;
  display: block;
  text-decoration: none;
  padding: 2px;
  z-index: 2;
  margin: 3.2vh 0;
  box-shadow: none;
  border: 2px;
}
@media (max-width: 1200px) {
  .blogAddButton {
    height: 6.5vh;
    width: 21vh;
  }
}
@media (max-width: 768px) {
  .blogAddButton {
    height: 6.6603518268vh;
    width: 20vh;
  }
}

.blogAddButton:hover {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.72) 0%, rgb(240, 89, 42) 50%, rgba(240, 89, 42, 0.59) 100%) !important;
}

.blogAddButton span {
  color: white !important;
  align-items: center;
  background: #201b36 !important;
  border-radius: 5.4127198917vh !important;
  display: flex;
  justify-content: center;
  height: 100%;
  transition: background 0.5s ease;
  width: 100%;
  font-size: 2.4vh !important;
  font-weight: 400 !important;
  padding: 1.5vh 2.5vh !important;
}

.blogAddButton:hover span {
  background: #f0592a !important;
  color: white !important;
}

.blogEditCard .ant-card-head {
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(126deg, rgb(255, 255, 255) 0%, rgba(240, 89, 42, 0.59) 35%) 1;
}

.bet-tab .ant-tabs-nav-wrap {
  display: flex !important;
  justify-content: left !important;
}

.bet-tab .ant-tabs-tab {
  font-size: 1.3vw !important;
  font-weight: 400 !important;
  color: #fff;
  border-bottom: 1px solid #fff !important;
}
@media (max-width: 1024px) {
  .bet-tab .ant-tabs-tab {
    font-size: 1.1rem !important;
  }
}

.bet-tab .ant-tabs-tab-active {
  font-size: 1.3vw !important;
  font-weight: 400;
  filter: none;
  opacity: 1;
  color: #f0592a !important;
}
@media (max-width: 1024px) {
  .bet-tab .ant-tabs-tab-active {
    font-size: 1.1rem !important;
  }
}

.bet-tab .ant-tabs-ink-bar::after {
  background: #f0592a !important;
  height: 4px !important;
  content: "";
  position: absolute !important;
  left: 0;
  right: 0;
  bottom: 0;
}

.BlogEditDiv {
  width: 100%;
  border-radius: 1.4vh;
  background: linear-gradient(45deg, rgb(255, 182, 160), rgb(240, 89, 42)) !important;
  padding: 1px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/BlogEditTab/blogEditTab.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF;AAEA;EACE,cAAA;AAAF;AACE;EAFF;IAGI,0BAAA;EAEF;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,yBAAA;AAEF;AADE;EAFF;IAGI,uBAAA;EAIF;AACF;;AAFA;EACE,0BAAA;AAKF;;AAFA;EACE,0BAAA;AAKF;;AAFA;EACE,2BAAA;EACA,gBAAA;EACA,yBAAA;AAKF;AAJE;EAJF;IAKI,0BAAA;EAOF;AACF;;AAJA;EACE,2BAAA;EACA,gBAAA;EACA,yBAAA;AAOF;AANE;EAJF;IAKI,0BAAA;EASF;AACF;;AANA;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AASF;AARE;EALF;IAMI,0BAAA;IACA,kBAAA;EAWF;AACF;;AARA;EACE,8BAAA;EACA,qHAAA;EAMA,yCAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EAEA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAKF;AAJE;EAnBF;IAoBI,aAAA;IACA,WAAA;EAOF;AACF;AANE;EAvBF;IAwBI,sBAAA;IACA,WAAA;EASF;AACF;;AANA;EACE,gIAAA;AASF;;AADA;EACE,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;AAIF;;AADA;EACE,8BAAA;EACA,uBAAA;AAIF;;AADA;EACE,oCAAA;EACA,2FAAA;AAIF;;AAIA;EACE,wBAAA;EACA,gCAAA;AADF;;AAIA;EACE,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,wCAAA;AADF;AAEE;EALF;IAMI,4BAAA;EACF;AACF;;AAEA;EACE,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AACF;AAAE;EANF;IAOI,4BAAA;EAGF;AACF;;AAAA;EACE,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,6BAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAGF;;AAAA;EACE,WAAA;EACA,oBAAA;EACA,mFAAA;EAKA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF","sourcesContent":[".blogEditMain {\n  width: 100%;\n}\n\n.blogEditCard {\n  width: 100%;\n  background: #181434;\n}\n\n@media (max-width: 768px) {\n  .blogEditCard .ant-card-body {\n    padding: 12px;\n  }\n}\n\n.blogAddImgText {\n  font-size: 1vw;\n  @media (max-width: 768px) {\n    font-size: 14px !important;\n  }\n}\n\n.blogTabBreadCrumb {\n  width: 100%;\n  text-align: left;\n  font-size: 20px;\n  font-weight: 400;\n  margin-bottom: 24px;\n}\n\n.blogTabBreadCrumb .ant-breadcrumb-link {\n  color: #f0592a ;\n}\n\n.ant-upload-wrapper .ant-upload-drag .ant-upload {\n  padding: 1.1vw !important;\n  @media (max-width: 768px) {\n    padding: 8px !important;\n  }\n}\n.ant-upload-wrapper .ant-upload-drag {\n  border: 1px dashed #ffb6a0;\n}\n\n.ant-upload-wrapper .ant-upload-drag:not(.ant-upload-disabled):hover {\n  border: 1px dashed #ffb6a0;\n}\n\n.blogEditCard .ant-card-head-title {\n  font-size: 1.4vw !important;\n  font-weight: 400;\n  color: #f0592a !important;\n  @media (max-width: 1024px) {\n    font-size: 20px !important;\n  }\n}\n\n.blogContentText {\n  font-size: 1.4vw !important;\n  font-weight: 400;\n  color: #f0592a !important;\n  @media (max-width: 1024px) {\n    font-size: 20px !important;\n  }\n}\n\n.blogUploaderText2 {\n  color: #fff;\n  font-size: 1vw;\n  text-align: left;\n  padding-left: 2rem;\n  @media (max-width: 768px) {\n    font-size: 14px !important;\n    padding-left: 12px;\n  }\n}\n\n.blogAddButton {\n  background: rgb(255, 255, 255);\n  background: linear-gradient(\n    165deg,\n    rgba(255, 255, 255, 0.72) 0%,\n    rgba(240, 89, 42, 1) 50%,\n    rgba(240, 89, 42, 0.59) 100%\n  );\n  border-radius: 12.990527740189446vh !important;\n  box-sizing: border-box;\n  color: #fff !important;\n  display: block;\n  //   height: 8.660351826792963vh;\n  text-decoration: none;\n  padding: 2px;\n  z-index: 2;\n  margin: 3.2vh 0;\n  box-shadow: none;\n  border: 2px;\n  @media (max-width: 1200px) {\n    height: 6.5vh;\n    width: 21vh;\n  }\n  @media (max-width: 768px) {\n    height: 6.660351826792963vh;\n    width: 20vh;\n  }\n}\n\n.blogAddButton:hover {\n  background: linear-gradient(\n    165deg,\n    rgba(255, 255, 255, 0.72) 0%,\n    rgba(240, 89, 42, 1) 50%,\n    rgba(240, 89, 42, 0.59) 100%\n  ) !important;\n}\n\n.blogAddButton span {\n  color: white !important;\n  align-items: center;\n  background: #201b36 !important;\n  border-radius: 5.412719891745602vh !important;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  transition: background 0.5s ease;\n  width: 100%;\n  font-size: 2.4vh !important;\n  font-weight: 400 !important;\n  padding: 1.5vh 2.5vh !important;\n}\n\n.blogAddButton:hover span {\n  background: #f0592a !important;\n  color: white !important;\n}\n\n.blogEditCard .ant-card-head {\n  border-bottom: 2px solid transparent;\n  border-image: linear-gradient(\n      126deg,\n      rgba(255, 255, 255, 1) 0%,\n      rgba(240, 89, 42, 0.59) 35%\n    )\n    1;\n}\n\n.bet-tab .ant-tabs-nav-wrap {\n  display: flex !important;\n  justify-content: left !important;\n}\n\n.bet-tab .ant-tabs-tab {\n  font-size: 1.3vw !important;\n  font-weight: 400 !important;\n  color: #fff;\n  border-bottom: 1px solid #fff !important;\n  @media (max-width: 1024px) {\n    font-size: 1.1rem !important;\n  }\n}\n\n.bet-tab .ant-tabs-tab-active {\n  font-size: 1.3vw !important;\n  font-weight: 400;\n  filter: none;\n  opacity: 1;\n  color: #f0592a !important;\n  @media (max-width: 1024px) {\n    font-size: 1.1rem !important;\n  }\n}\n\n.bet-tab .ant-tabs-ink-bar::after {\n  background: #f0592a !important;\n  height: 4px !important;\n  content: \"\";\n  position: absolute !important;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.BlogEditDiv {\n  width: 100%;\n  border-radius: 1.4vh;\n  background: linear-gradient(\n    45deg,\n    rgba(255, 182, 160, 1),\n    rgba(240, 89, 42, 1)\n  ) !important;\n  padding: 1px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
